import {useEffect, useState} from "react";
import {NavigateFunction, useNavigate} from "react-router-dom";

import {LogContext, LogContextType} from "@/context/LogContex";

import {useGetContext} from "../useGetContext/useGetContext";

export const testConnection = (
  isConnected: boolean,
  navigate: NavigateFunction,
  setIsAuthorized:
    | React.Dispatch<React.SetStateAction<boolean>>
    | undefined = undefined
): void => {
  const pageWithoutLogin = ["/connexion", "/rgpd"];
  if (!isConnected && !pageWithoutLogin.includes(location.pathname)) {
    if (location.pathname === "/") {
      navigate("/connexion");
    } else {
      navigate("/connexion");
      alert("vous devez être connecter pour accéder à cette page");
    }
  }
  if (setIsAuthorized !== undefined) {
    if (isConnected) {
      setIsAuthorized(true);
    } else {
      setIsAuthorized(false);
    }
  }
};

export function useIsConnectedTest(): boolean {
  const navigate = useNavigate();
  const {isConnected} = useGetContext<LogContextType>(LogContext, "LogContext");
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    testConnection(isConnected, navigate, setIsAuthorized);
  }, [isConnected]);
  return isAuthorized;
}
